export default __webpack_public_path__ + "media/images/map/car/32x32_inactive-071a5fa0a4470a70ae04bbcc239cf466.png";